import rawCounties from "./counties.json" with { type: "json" };

export type CountiesByCountry = Record<string, Record<string, string[]>>;

export const COUNTIES_BY_COUNTRY = rawCounties as CountiesByCountry;

export function listStatesForCountry(country: string): { label: string; value: string }[] {
  const byState = COUNTIES_BY_COUNTRY[country];
  if (!byState) return [];
  return Object.keys(byState)
    .sort((a, b) => a.localeCompare(b))
    .map((s) => ({ label: s, value: s }));
}

export function listCountiesForState(
  country: string,
  state: string,
): { label: string; value: string }[] {
  const byState = COUNTIES_BY_COUNTRY[country];
  const list = byState?.[state];
  if (!list) return [];
  return list.map((c) => ({ label: c, value: c }));
}
